import React, { useState } from 'react';
import _ from 'lodash';
import { Stack, Button, Card, CardContent, Typography, Fab, Checkbox, Box, Select, MenuItem } from '@mui/material';
import { SmallFormDateField } from '../../../../../components/small-fields/SmallFormDateField';
import { SmallFormTextField } from '../../../../../components/small-fields/SmallFormTextField';
import UndoIcon from '@mui/icons-material/Undo';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageModal from './ImageModal';
import defaultImage from './default.png';
import { useNavigate } from 'react-router-dom';
import { useAccounts } from '../../Context';


export default function EmployeeDataBase({ formik, preview, loading, fileInputRef, handleChangeImage, handlePhotoChange, isDefaultPhoto }) {
  const [openImage, setOpenImage] = React.useState(false);
  const navigate = useNavigate();
  const { choices, rowData } = useAccounts();

  const handleOpenEmployee = () => {
    navigate('/employee/employees');
    // { state: { employeeData: rowData }
  };

  return (
    <Stack sx={{ mt: 2 }} direction="row" spacing={2}>
      <Card sx={{ width: '200px', height: '250px' }}>
        <CardContent>
          <img
            src={preview}
            style={{ objectFit: 'cover', width: '150px', height: '150px', margin: '0 auto', border: '2px solid #00AB55', borderRadius: '16px', cursor: 'zoom-in' }}
            onClick={() => setOpenImage(true)}
          >
          </img>
          <Stack style={{ marginTop: '10px' }} direction="row" justifyContent="space-between">
            <Button variant="contained" component="label" disabled={loading}>
            Zmień
              <input type="file" accept="image/*" hidden ref={fileInputRef} onChange={handleChangeImage}/>
            </Button>
            {
              formik.values.is_photo_changed || formik.values.is_photo_deleted
                ? <Fab size="small" color="secondary" onClick={() => handlePhotoChange(false)} disabled={loading}>
                  <UndoIcon />
                </Fab>
                : <Fab size="small" color="error" disabled={preview === defaultImage || isDefaultPhoto || loading} onClick={() => handlePhotoChange(true)}>
                  <DeleteIcon />
                </Fab>
            }
          </Stack>
        </CardContent>
      </Card>
      <Card sx={{ flex: 1 }}>
        <CardContent>
          <Stack spacing={2}>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Imię</Typography>
              <SmallFormTextField
                name="first_name"
                placeholder="Imię"
                value={formik.values.first_name}
                onChange={formik.handleChange}
                helperText={formik.errors.first_name}
                error={formik.errors.name && formik.touched.first_name}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Nazwisko</Typography>
              <SmallFormTextField
                name="last_name"
                placeholder="Naziwsko"
                value={formik.values.last_name}
                onChange={formik.handleChange}
                helperText={formik.errors.last_name}
                error={formik.errors.surname && formik.touched.last_name}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Terminy OL spoza aplikcji</Typography>
              <Select
                multiple
                name="camps"
                id="camps_field"
                value={formik.values.camps}
                onChange={formik.handleChange}
                helperText={formik.errors.camps}
                error={formik.errors.surname && formik.touched.camps}
                sx={{ width: '75%' }}
              >
                {!_.isEmpty(choices.camps)
                  ? _.map(choices.camps, obj => (
                    <MenuItem value={obj.value} key={obj.value} style={{ whiteSpace: 'normal' }}>
                      {obj.label}
                    </MenuItem>
                  ))
                  : [] }
              </Select>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Terminy ZS spoza aplikcji</Typography>
              <Select
                multiple
                name="zs_weeks_periods"
                id="zs_weeks_periods_field"
                value={formik.values.zs_weeks_periods.map(obj => obj.name)}
                onChange={event => {
                  const selectedValues = event.target.value;
                  const selectedObjects = choices.zs_weeks_periods.filter(obj => selectedValues.includes(obj.name));
                  formik.setFieldValue('zs_weeks_periods', selectedObjects);
                }}
                sx={{ width: '75%' }}
              >
                {!_.isEmpty(choices.zs_weeks_periods)
                  ? _.map(choices.zs_weeks_periods, obj => (
                    <MenuItem value={obj.name} key={obj.name} style={{ whiteSpace: 'normal' }}>
                      {obj.name}
                    </MenuItem>
                  ))
                  : []}
              </Select>
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2" sx={{ width: '25%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'pre' }}>Email</Typography>
              <SmallFormTextField
                name="email"
                placeholder="Email"
                value={formik.values.email}
                onChange={formik.handleChange}
                helperText={formik.errors.email}
                error={formik.errors.email && formik.touched.email}
                sx={{ width: '75%' }}
              />
            </Stack>
            <Stack direction="row" alignItems="center" justifyContent="left" spacing={1}>
              <Typography variant="subtitle2">Aktywny</Typography>
              <Box width={180}/>
              <Checkbox id="is_active" name="is_active" checked={formik.values.is_active} onChange={formik.handleChange} />
            </Stack>
            {rowData.groups_display == 'kadra zarządzająca' && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} width="30%">
              <Typography variant="subtitle2">Wysyłaj maile na adres użytkownika kadry</Typography>
              <Box width={180}/>
              <Checkbox id="is_active" name="send_mails_to_manager_user_email" checked={formik.values.send_mails_to_manager_user_email} onChange={formik.handleChange} />
            </Stack>}
            {rowData.groups_display == 'kadra zarządzająca' && <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} width="30%">
              <Typography variant="subtitle2">Ukryj pracowników w panelu kadry</Typography>
              <Box width={180}/>
              <Checkbox id="is_active" name="manager_hide_employees" checked={formik.values.manager_hide_employees} onChange={formik.handleChange} />
            </Stack>}
          </Stack>
          <Stack justifyContent={'end'}>
            <Button
              onClick={handleOpenEmployee}>Przejdź do pracownika</Button>
          </Stack>
        </CardContent>
      </Card>
      <ImageModal open={openImage} handleClose={() => setOpenImage(false)} src={preview}/>
    </Stack>);
};
